<script setup>
    const { data } = await useStatamicEntries().getEntryBySlug({
        collection: 'campaigns',
        value: currentSlug(),
    })

    const carEntry = await useStatamicEntries().getEntryById({
        collection: 'cars',
        value: data?.value?.campaign_car?.id ?? '',
    })

    const carData = carEntry?.data?.value ?? {}

    const store = useStore()

    store.selectCar(carData)

    setTimeout(() => {
        store.updateSelectedQuote(true)
    }, 1000)



    useHead({
        title: (() => {
            if (data.value.title != 'Home') {
                return data.value.title
            }

            return null
        })(),
    })
</script>

<template>
    <div v-if="data" class="campaign-content w-full">
        <CampaignBanner :campaignData="data" :carData="carData" />

        <div class="text-content container mt-10" v-html="data.content"></div>

        <QuoteBuilderStep2 v-if="store.selectedCar" :hideRelatedCars="true" />
    </div>

    <div v-else class="text-center">
        <h1 class="mb-2 text-brand2">Page not found</h1>
        <p>The page you requested couldn't be found.</p>
        <p>
            <NuxtLink to="/" class="text-brand1 underline hover:no-underline">
                Return to the home page
            </NuxtLink>
        </p>
    </div>
</template>

<style scoped>
    .text-content {
       :deep(p) {
            @apply mb-6;
        }
    }

    :deep(.selected-car-details) {
        display:none;
    }

    :deep(nav) {
        display: none;
    }

    :deep(header > a) {
        display: none;
    }
</style>
